// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__9goyT","link":"Header_link__3FJ86","activeLink":"Header_activeLink__1k1kB"};